
import { Component, Vue } from 'vue-property-decorator';
import MyCompanyAppUsersById from '@/pages/mycompany/appusers/_id.vue';
import OsSheet from '@/components/core/sheet/OsSheet.vue';
@Component({
  components: { OsSheet, MyCompanyAppUsersById }
})
export default class AppUsersById extends Vue {}
